import { TestServiceService } from './../../../../core/services/testService/test-service.service';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  maxCompetence,
  minCompetence,
  serverError,
  successCreateTest,
} from './../../../../core/models/messages';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-add-test-wegestu',
  templateUrl: './add-test-wegestu.component.html',
  styleUrls: ['./add-test-wegestu.component.css'],
})
export class AddTestWegestuComponent {
  selectedSubcategoryIds: any[] = [];
  private unsubscribeAll: Subject<void> = new Subject();
  jobId: any;
  skillsList: any;
  totalItems: number = 10;
  endIndex: number = 10;
  value: any;
  action: string = "";
  colors = ['#FBF2E9', '#E8F6FC', '#FDEFEE', '#FFF3D7', '#FBF2E9'];
  selectedSubcategories: any;
  competences = [
    { id: 1, name: 'Python' },
    { id: 2, name: 'laravel' },
    { id: 3, name: 'angular' },
    { id: 4, name: 'javascript' },
    { id: 5, name: 'java' },
  ];

  testType: string | null | undefined

  constructor(
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private testService: TestServiceService
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.testType = navigation.extras.state['testType'];
    } 

    this.activatedRoute.queryParams.subscribe(params => {
      this.jobId = params['jobId'];
      this.action = params['action'];
      this.value = params['state'];
    });
  }

  ngOnInit() {
    if(!this.testType){
      this.router.navigateByUrl('/offres-emploi/liste-offres-emploi')
    }
    this.getSkills();
  }

  navigateToBareme(){
    this.router.navigate([
      '/offres-emploi/add-bareme',
      { jobId: this.jobId , state:0},
    ]);
  }
  /* create test*/
  createTest(data: number[]) {
    this.testService
      .CreateTestWegestu({ sub_category_ids: data, job_offer_id: this.jobId })
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.toastrService.success(successCreateTest);
              {
                this.router.navigate([
                  '/offres-emploi/liste-offres-emploi',
                  { jobId: this.jobId },
                ]);
              }
       
          }
        },
        error: (err: any) => {
          if(err.error.message ==  'No questions found.'){
            this.toastrService.error('Aucune question trouvée');

          }
          else{
            this.toastrService.error(serverError);

          }
        },
      });
  }
  /* selected modules */
  sendSelectedModules() {
    // Check if sub_category_ids array is empty
    if (this.selectedSubcategoryIds.length === 0) {
      this.toastrService.error(minCompetence);
      return;
    } else if (this.selectedSubcategoryIds.length > 5) {
      // If more than 5 items are selected show error message
      this.toastrService.error(maxCompetence);
      return;
    } else {
      this.createTest(this.selectedSubcategoryIds);
    }
  }

  /* select skills*/
  onCheckboxChange(subcategory: any, event: any) {
    const isChecked = event.target.checked;
    subcategory.selected = isChecked;
    this.updateSelectedSubcategories();
  }

  /* update subcategorie*/
  updateSelectedSubcategories() {
    const selectedSubcategoryNames: string[] = [];
    this.skillsList.forEach((category: any) => {
      if (category && category.subcategories) {
        const subcategory = category.subcategories;
        for (let i = 0; i < subcategory.length; i++) {
          if (subcategory[i].selected) {
            selectedSubcategoryNames.push(subcategory[i].name_FR);
            if (!this.selectedSubcategoryIds.includes(subcategory[i].id)) {
              this.selectedSubcategoryIds.push(subcategory[i].id);
            }
          } else {
            const index = this.selectedSubcategoryIds.indexOf(
              subcategory[i].id
            );
            if (index !== -1) {
              this.selectedSubcategoryIds.splice(index, 1);
            }
          }
        }
      }
    });
  }
  getSkills() {
    this.spinner.show();
    this.testService
      .getSkills(this.jobId)
      .pipe()
      .subscribe({
        next: (res) => {
          // this.totalItems = res.data[0].count
          this.skillsList = res.data;
          this.spinner.hide();
        },
        error: (err) => {
          this.spinner.hide();
        },
      });
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  redirectTest(): void {
      this.router.navigate(['/offres-emploi/add-test'], {
        queryParams: { jobId: this.jobId },
        state: {  testType: 'NO_TEST' },
      });
  }

}
